export default "__VITE_ASSET__BPfJGN3Z__"